import { BreadcrumbProps, Button, Icon, NumberDisplay, Tooltip } from '@aidkitorg/component-library';
import { usePayments } from '../../Contexts/PaymentsContext';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';
import { PaymentsDataTable } from './components/PaymentsDataTable';

export const PaymentsPage = () => {
  const L = useLocalizedStrings()

  const {
    fetchPaymentsOverview, 
    enabledPayments, 
    paymentsDataTimestamp,

    isPaymentsLoading
  } = usePayments();

  const enabledPaymentsCard = <NumberDisplay
    loading={isPaymentsLoading}
    className="sm:max-w-64"
    title={L.admin_panel.payments.enabled_payments}
    value={enabledPayments} 
    unit={L.admin_panel.payments.payments}
    unitSingular={L.admin_panel.payments.payment}
    iconName="PlayCircleIcon" 
    iconColor="blue"
  />

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.accounting,
    }
  ];

  return (
    <AdminPanelPage
      title={L.admin_panel.nav.payments}
      description={L.admin_panel.payments.payments_about}
      breadcrumbs={breadcrumbs}
      pageActionButtons={[
        <Tooltip text={L.admin_panel.payments.refresh_data} asChild>
          <Button
            size="sm"
            variant='secondary'
            onClick={() => { fetchPaymentsOverview(true) }}
            icon={<Icon role="decorative" type="solid" name="ArrowPathIcon" />}
            aria-label={L.admin_panel.payments.refresh_data}
          />
        </Tooltip>
      ]}
    >
      <div className="flex flex-col gap-2 sm:gap-4 w-full">
        <div>
          {enabledPaymentsCard}
        </div>
        <div>
          <PaymentsDataTable lastUpdatedTimestamp={paymentsDataTimestamp} />
        </div>
      </div>
    </AdminPanelPage>
  )
}